/* Live Ops terminal — streams randomised order/stock/system events.
   All client-side and decorative; builds each line with DOM APIs. Pauses
   while the tab is hidden. */
(function () {
  'use strict';

  function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function ri(min, max) { return Math.floor(min + Math.random() * (max - min + 1)); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function init(root) {
    if (!root || root.dataset.ltInit) return;
    root.dataset.ltInit = '1';

    var body = root.querySelector('[data-terminal-body]');
    if (!body) return;

    var cities = (root.dataset.cities || 'München,Berlin,Hamburg')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var products = (root.dataset.products || 'F*CK IT.,HUSTLE')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var minGap = (parseInt(root.dataset.min, 10) || 2) * 1000;
    var maxGap = (parseInt(root.dataset.max, 10) || 6) * 1000;
    if (maxGap < minGap) maxGap = minGap + 1000;

    var sizes = ['S', 'M', 'L', 'XL'];
    var prices = ['9,90', '24,90', '29,90'];
    var stock = parseInt(root.dataset.stock, 10) || 92;
    var viewers = ri(18, 44);

    /* clock starts a couple minutes in the past and ticks forward */
    var clock = new Date();
    clock.setMinutes(clock.getMinutes() - 3);

    function stamp() {
      clock.setSeconds(clock.getSeconds() + ri(3, 40));
      return pad(clock.getHours()) + ':' + pad(clock.getMinutes()) + ':' + pad(clock.getSeconds());
    }

    /* event generators return { tag, cls, html } */
    var generators = [
      function order() {
        stock = Math.max(3, stock - ri(1, 2));
        return {
          tag: 'ORDER', cls: 'order',
          html: 'new order · <b>' + rand(products) + '</b> (' + rand(sizes) + ') → ' + rand(cities)
        };
      },
      function order2() {
        stock = Math.max(3, stock - 1);
        return {
          tag: 'ORDER', cls: 'order',
          html: '#' + ri(4000, 4999) + ' confirmed · ' + rand(cities) + ' · <span class="lt-eur">€' + rand(prices) + '</span>'
        };
      },
      function paid() {
        return {
          tag: 'PAID', cls: 'paid',
          html: 'payment captured · <span class="lt-eur">€' + rand(prices) + '</span> · ' + rand(cities)
        };
      },
      function stockLine() {
        var cls = stock < 25 ? 'stock' : 'stock';
        var warn = stock < 25 ? ' <span class="lt-warn">low</span>' : '';
        return {
          tag: 'STOCK', cls: cls,
          html: 'lot 2026-003 · <b>' + stock + '</b> units remaining' + warn
        };
      },
      function view() {
        viewers = Math.max(9, viewers + ri(-4, 6));
        return {
          tag: 'LIVE', cls: 'view',
          html: '<b>' + viewers + '</b> people viewing the drop right now'
        };
      },
      function sys() {
        return {
          tag: 'SYS', cls: 'sys',
          html: 'batch #01 // diminishing · restock not scheduled'
        };
      },
      function get() {
        return {
          tag: 'GET', cls: 'get',
          html: 'GET /collections/all 200 · ' + ri(40, 180) + 'ms · ' + rand(cities)
        };
      }
    ];

    /* weight orders/stock higher than plumbing lines */
    var weighted = [0, 0, 0, 1, 1, 2, 3, 4, 5, 6];

    var cursor = document.createElement('div');
    cursor.className = 'lt-cursor';
    cursor.innerHTML = '<span class="lt-line__ts">' + '&gt;' + '</span><i></i>';

    function addLine(ev) {
      var line = document.createElement('div');
      line.className = 'lt-line';
      var ts = document.createElement('span');
      ts.className = 'lt-line__ts';
      ts.textContent = stamp();
      var tag = document.createElement('span');
      tag.className = 'lt-line__tag lt-line__tag--' + ev.cls;
      tag.textContent = ev.tag;
      var msg = document.createElement('span');
      msg.className = 'lt-line__msg';
      msg.innerHTML = ev.html;
      line.appendChild(ts);
      line.appendChild(tag);
      line.appendChild(msg);
      body.insertBefore(line, cursor);

      while (body.querySelectorAll('.lt-line').length > 14) {
        body.removeChild(body.querySelector('.lt-line'));
      }
    }

    var timer = null;
    function tick() {
      addLine(generators[rand(weighted)]());
      timer = setTimeout(tick, ri(minGap, maxGap));
    }

    /* seed the feed so it isn't empty on load */
    body.appendChild(cursor);
    for (var i = 0; i < 6; i++) addLine(generators[rand(weighted)]());

    timer = setTimeout(tick, 1200);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        clearTimeout(timer);
      } else {
        clearTimeout(timer);
        timer = setTimeout(tick, ri(minGap, maxGap));
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-live-terminal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-live-terminal]');
    if (root) init(root);
  });
})();
